export default function Loader({
  borderColor = "gray-400",
  className = "",
  wrapperClassName = "",
}: {
  borderColor?: string;
  className?: string;
  wrapperClassName?: string;
}) {
  return (
    <div className={`min-h-dvh flex-center h-full w-full ${wrapperClassName}`}>
      <div className="relative">
        <div
          className={`size-10 border-2 border-t-transparent border-${borderColor} border-b-transparent rounded-full animate-spin ${className}`}
        />
      </div>
    </div>
  );
}
